import React, { useCallback, useState } from 'react';
import { connect } from "react-redux";
import OMTransactionHistorySearchForm from './OMTransactionHistorySearchForm.js';
import DxTabPanel, { Item } from "devextreme-react/tab-panel";
import { useHistory, useParams } from 'react-router-dom';
import '../../common/css/searchPage.css';
const tabs = [

];
const OMTransactionHistoryMain = (props) => {
  const history = useHistory();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
      history.push('/om/history');
    }
  }, []);
  const [filteredTabs, setFilteredTabs] = useState(tabs);
  return (
    <div className="search-page-container">
      <OMTransactionHistorySearchForm selectedTab = "History" />
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(OMTransactionHistoryMain);